import { Panel as DialogPanel, Toolbar } from '@common/components/Dialog/Dialog.styles';
import Markdown from '@common/components/Markdown';

import { Dialog as HeadlessDialog } from '@headlessui/react';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 60px 30px 60px;
`;

export const HeadingContainer = styled(HeadlessDialog.Title)`
  text-align: center;
`;

export const Panel = styled(DialogPanel)`
  max-width: 48rem;
`;

export const StyledToolbar = styled(Toolbar)`
  margin-bottom: 0;
`;

export const StyledMarkdown = styled(Markdown)`
  color: ${({ theme }) => theme.defaultColors.fontPrimary};

  & p {
    font-size: 15px;
    line-height: 22.5px;
    margin-bottom: 0;
  }
`;
